export const articles = [
  {
    id: '1',
    slug: 'top-star-divorce-scandal',
    title: '顶流男星深夜发文宣布离婚，三年婚姻画上句号，粉丝集体崩溃',
    excerpt: '娱乐圈再爆重磅消息，一线男星凌晨在社交平台发布长文，正式宣布与妻子结束三年的婚姻关系。消息一出，立即引爆全网热搜。据悉，两人因工作聚少离多，感情逐渐疏远...',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    image: 'https://readdy.ai/api/search-image?query=Soft%20warm%20ambient%20lighting%20on%20a%20minimalist%20scene%20with%20a%20single%20spotlight%20on%20an%20empty%20stage%2C%20dramatic%20atmosphere%2C%20emotional%20and%20cinematic%20mood%2C%20soft%20shadows%2C%20professional%20editorial%20photography%2C%20neutral%20beige%20and%20cream%20background%2C%20high%20detail%2C%20clean%20aesthetic&width=800&height=600&seq=article-divorce-001&orientation=landscape',
    isFeatured: true,
    isVideo: false,
    date: '2026-07-07',
    readTime: '8分钟',
    views: 128500,
    comments: 3621,
    content: '详细内容将在文章页展开...',
    tags: ['离婚', '顶流男星', '娱乐圈', '深夜发文'],
  },
  {
    id: '2',
    slug: 'wanghong-live-broadcast-accident',
    title: '知名女主播直播事故引发热议，平台连夜发布处理公告',
    excerpt: '拥有千万粉丝的知名女主播在昨晚直播中发生意外事故，画面被网友截图疯传。平台方凌晨紧急发布声明，表示将对该主播进行停播处理。事件持续发酵，相关话题阅读量已突破3亿...',
    category: '网红爆料',
    categorySlug: 'internet-drama',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20studio%20lighting%20with%20vibrant%20pink%20and%20warm%20orange%20glow%2C%20live%20streaming%20equipment%20silhouette%20against%20colorful%20bokeh%20background%2C%20modern%20digital%20atmosphere%2C%20professional%20photography%2C%20clean%20minimal%20composition%2C%20soft%20shadows%2C%20neutral%20cream%20background&width=800&height=600&seq=article-live-002&orientation=landscape',
    isFeatured: true,
    isVideo: true,
    date: '2026-07-07',
    readTime: '6分钟',
    views: 256000,
    comments: 8942,
    content: '详细内容将在文章页展开...',
    tags: ['女主播', '直播事故', '平台公告', '停播'],
  },
  {
    id: '3',
    slug: 'new-drama-filming-leaked',
    title: '新剧片场路透曝光！当红小花古装造型惊艳全场',
    excerpt: '近日，由知名导演执导的古装大剧正在横店热拍。有网友拍到当红小花在片场的路透照，古装造型精致绝美，引发网友热议。据悉该剧投资高达3亿，预计明年暑期档播出...',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20traditional%20Chinese%20costume%20draped%20on%20a%20stand%20against%20soft%20golden%20backdrop%2C%20warm%20ambient%20lighting%2C%20cinematic%20film%20set%20atmosphere%2C%20dreamy%20bokeh%2C%20professional%20editorial%20photography%2C%20clean%20composition%2C%20neutral%20cream%20and%20beige%20tones&width=800&height=600&seq=article-costume-003&orientation=landscape',
    isFeatured: false,
    isVideo: false,
    date: '2026-07-06',
    readTime: '5分钟',
    views: 98500,
    comments: 2156,
    content: '详细内容将在文章页展开...',
    tags: ['古装剧', '路透', '小花', '片场'],
  },
  {
    id: '4',
    slug: 'music-festival-secret-romance',
    title: '音乐节后台甜蜜互动被拍，这对CP终于藏不住了？',
    excerpt: '在刚刚结束的草莓音乐节上，有眼尖的粉丝拍到两位当红歌手在后台亲密互动的画面。两人此前曾多次合作，绯闻传了两年之久。这次实锤照片流出，粉丝纷纷表示终于等到了...',
    category: '黑料吃瓜',
    categorySlug: 'scandal',
    image: 'https://readdy.ai/api/search-image?query=Music%20festival%20atmosphere%20with%20colorful%20stage%20lights%20in%20soft%20focus%2C%20warm%20evening%20glow%2C%20festival%20crowd%20silhouettes%2C%20dreamy%20and%20romantic%20mood%2C%20professional%20photography%2C%20clean%20minimal%20composition%2C%20neutral%20cream%20tones&width=800&height=600&seq=article-festival-004&orientation=landscape',
    isFeatured: false,
    isVideo: false,
    date: '2026-07-06',
    readTime: '7分钟',
    views: 189200,
    comments: 5123,
    content: '详细内容将在文章页展开...',
    tags: ['音乐节', 'CP', '歌手', '恋爱'],
  },
  {
    id: '5',
    slug: 'variety-show-controversy',
    title: '综艺节目剪辑引争议，当事人发长文回应节目组恶意剪辑',
    excerpt: '某热门综艺最新一期播出后，因剪辑问题引发巨大争议。参与录制的嘉宾深夜发长文，控诉节目组通过恶意剪辑制造矛盾，歪曲事实。节目组尚未做出回应，但相关话题已登顶热搜...',
    category: '黑料吃瓜',
    categorySlug: 'scandal',
    image: 'https://readdy.ai/api/search-image?query=Television%20studio%20with%20warm%20professional%20lighting%2C%20empty%20talk%20show%20set%20with%20comfortable%20chairs%2C%20dramatic%20atmosphere%2C%20cinematic%20mood%2C%20professional%20photography%2C%20clean%20composition%2C%20neutral%20cream%20and%20beige%20background&width=800&height=600&seq=article-tv-005&orientation=landscape',
    isFeatured: true,
    isVideo: false,
    date: '2026-07-05',
    readTime: '10分钟',
    views: 312000,
    comments: 12580,
    content: '详细内容将在文章页展开...',
    tags: ['综艺', '剪辑争议', '回应', '热搜'],
  },
  {
    id: '6',
    slug: 'influencer-makeup-brand-launch',
    title: '千万粉丝美妆博主自创品牌发布，首日销量破千万',
    excerpt: '知名美妆博主历时两年打造的个人品牌正式上线，首日销售额突破千万。产品线涵盖口红、眼影盘和粉底液三大系列。凭借其强大的粉丝基础和产品口碑，多个单品上线即售罄...',
    category: '网红爆料',
    categorySlug: 'internet-drama',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20cosmetics%20display%20on%20marble%20surface%20with%20soft%20natural%20lighting%2C%20luxurious%20beauty%20products%2C%20warm%20rose%20gold%20accents%2C%20professional%20product%20photography%2C%20clean%20minimal%20composition%2C%20neutral%20cream%20background&width=800&height=600&seq=article-makeup-006&orientation=landscape',
    isFeatured: false,
    isVideo: false,
    date: '2026-07-05',
    readTime: '6分钟',
    views: 156000,
    comments: 4250,
    content: '详细内容将在文章页展开...',
    tags: ['美妆', '品牌', '博主', '销量'],
  },
  {
    id: '7',
    slug: 'movie-award-nomination-revealed',
    title: '金像奖提名名单出炉！黑马影片领跑，老牌影帝意外落选',
    excerpt: '第45届金像奖提名名单今日正式公布。一部低成本独立电影以12项提名领跑，成为最大黑马。而去年备受期待的某商业大片仅获2项技术类提名，令业界哗然...',
    category: '明星八卦',
    categorySlug: 'celebrity-gossip',
    image: 'https://readdy.ai/api/search-image?query=Golden%20trophy%20on%20dark%20elegant%20pedestal%20with%20soft%20spotlight%2C%20prestigious%20awards%20ceremony%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20photography%2C%20clean%20composition%2C%20neutral%20cream%20and%20warm%20gold%20background&width=800&height=600&seq=article-award-007&orientation=landscape',
    isFeatured: false,
    isVideo: false,
    date: '2026-07-04',
    readTime: '8分钟',
    views: 203000,
    comments: 6780,
    content: '详细内容将在文章页展开...',
    tags: ['金像奖', '提名', '黑马', '影帝'],
  },
  {
    id: '8',
    slug: 'esports-competition-upset',
    title: '电竞世界赛爆冷！中国战队让二追三逆转夺冠',
    excerpt: '在刚刚结束的英雄联盟全球总决赛中，中国战队在0:2落后的绝境下连扳三局，完成惊天逆转。这是中国战队时隔三年再次捧起冠军奖杯，赛后全网沸腾...',
    category: '每日更新',
    categorySlug: 'daily-update',
    image: 'https://readdy.ai/api/search-image?query=Energetic%20esports%20arena%20with%20colorful%20LED%20lights%20and%20excited%20atmosphere%2C%20gaming%20competition%20stage%20with%20dramatic%20lighting%2C%20professional%20photography%2C%20clean%20composition%2C%20neutral%20cream%20background%20with%20vibrant%20accents&width=800&height=600&seq=article-esport-008&orientation=landscape',
    isFeatured: true,
    isVideo: true,
    date: '2026-07-04',
    readTime: '7分钟',
    views: 456000,
    comments: 15230,
    content: '详细内容将在文章页展开...',
    tags: ['电竞', '夺冠', '逆转', '英雄联盟'],
  },
  {
    id: '9',
    slug: 'celebrity-charity-fundraiser',
    title: '明星慈善夜筹款破纪录，群星闪耀共献爱心',
    excerpt: '一年一度的明星慈善晚宴昨晚在上海隆重举行。近百位明星到场支持，现场筹款总额突破8000万，创下该活动历史新高。多位艺人慷慨解囊，场面温馨感人...',
    category: '每日更新',
    categorySlug: 'daily-update',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20charity%20gala%20venue%20with%20warm%20golden%20lighting%2C%20luxurious%20table%20settings%2C%20sophisticated%20evening%20atmosphere%2C%20professional%20photography%2C%20clean%20composition%2C%20neutral%20cream%20and%20champagne%20tones&width=800&height=600&seq=article-charity-009&orientation=landscape',
    isFeatured: false,
    isVideo: false,
    date: '2026-07-03',
    readTime: '5分钟',
    views: 112000,
    comments: 2340,
    content: '详细内容将在文章页展开...',
    tags: ['慈善', '明星', '晚宴', '筹款'],
  },
];

export const featuredArticles = articles.filter(a => a.isFeatured);
export const getArticleBySlug = (slug: string) => articles.find(a => a.slug === slug);
export const getArticlesByCategory = (categorySlug: string) => articles.filter(a => a.categorySlug === categorySlug);